export default __webpack_public_path__ + "static/logo1-e3624cea226f8efad27059826359f917.svg";